import { DateTimeEditor } from '@dataGrid/components/cellEditors';
import { withStyles } from "@material-ui/core";

const styles = () => ({
  inputRoot: {
    height: 32,
    borderRadius: "4px",
    width: 92,
  },
});

export default withStyles(styles)(DateTimeEditor);
